import { SOCIAL_SOURCES_OPTIONS } from "../../../../constants/static-filter.jsx";
import {
  getLineGraphFormat,
  getRandomUniqueColor,
} from "../../../Dashboard/data_formatter/format-utils";
import { GRAPH_TYPES } from "../../../../constants/app-constant";
const { AREA } = GRAPH_TYPES;

export const formatReachData = (d, graph_type, isLineGraph) => {
  try {
    const listOfPlatforms = SOCIAL_SOURCES_OPTIONS;
    let listOfTopics = d.map((topic) => topic.topic_name);

    let labels = listOfPlatforms.map((ss) => ss.label);
    const graphColors = getRandomUniqueColor(labels.length);

    const correctedlabels = isLineGraph
      ? getLineGraphFormat(listOfTopics, true)
      : listOfTopics;

    let datasets = listOfPlatforms.map((platform, index) => {
      let data = d.map((topic) => {
        let channelList = topic.channel_data;
        let channelEnity =
          (channelList.length &&
            channelList.filter((c) => c.channel_type == platform.id)) ||
          [];
        return channelEnity && channelEnity.length ? channelEnity[0].count : 0;
      });
      data = isLineGraph ? getLineGraphFormat(data) : data;

      return {
        label: platform.label,
        data,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      };
    });
    return {
      datasets,
      labels: correctedlabels,
    };
  } catch (e) {
    return {
      datasets: [],
      labels: [],
    };
  }
};
